<mat-toolbar *ngIf="isMobileAndSignedIn" class="menuIcon" [class.loggedOut]="!user" [class.isEmbedded]="isEmbedded">
    <button mat-icon-button (click)="onToggleMenu()" *ngxPermissionsOnly="['viewCustomer']">
        <mat-icon>menu</mat-icon>
    </button>
    <a class="ccLogo" *ngxPermissionsOnly="['viewCustomer']"></a>
</mat-toolbar>
<mat-sidenav-container class="fullHeight app-container" [class.isMobile]="isMobile">
    <mat-sidenav
        *ngIf="!isEmbedded && !isFirstSignup"
        #sidenav
        role="navigation"
        mode="side"
        [opened]="isNotMobileAndSignedIn"
        [fixedInViewport]="!isMobile"
    >
        <div class="sidenav-container">
            <div class="side-menu main-menu">
                <ng-container *ngIf="user">
                    <clare-sidenav-new [user]="user" [isMobile]="isMobile"></clare-sidenav-new>
                </ng-container>
            </div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content id="mainContent">
        <ng-container *ngxPermissionsExcept="['viewCustomerPortal']">
            <app-info-banner *ngIf="user?.id && !isEmbedded"></app-info-banner>
        </ng-container>
        <div class="main-content" [ngClass]="{ 'full-height': isMobile && isSideNavOpen }">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
